// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon5(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M2.372 18.628h3.094a.333.333 0 1 0 0-.667H2.372a.333.333 0 0 0 0 .667ZM5.466 20.197H2.372a.333.333 0 1 0 0 .667h3.094a.333.333 0 1 0 0-.667ZM4.062 22.434h-1.69a.333.333 0 1 0 0 .666h1.69a.333.333 0 0 0 0-.666Z" />
        <path d="M30.56 12.414h-1.587v-4.04a.333.333 0 0 0-.333-.333h-2.05a14.03 14.03 0 0 0-2.043-7 1.897 1.897 0 0 0-3.334.173 3.666 3.666 0 0 1-3.36 2.154h-7.7a4.527 4.527 0 0 0-4.436 3.546l-.254 1.127H3.36a.333.333 0 0 0-.333.333v4.04H1.44A1.443 1.443 0 0 0 0 13.854v14.194a3.823 3.823 0 0 0 3.82 3.82h24.36a3.823 3.823 0 0 0 3.82-3.82V13.854a1.444 1.444 0 0 0-1.44-1.44ZM6.367 7.061a3.867 3.867 0 0 1 3.786-3.027H21.86a.333.333 0 1 0 0-.666h-1.667a4.406 4.406 0 0 0 1.64-1.874 1.227 1.227 0 0 1 2.154-.106 13.377 13.377 0 0 1 1.953 6.666H6.147l.22-.993Zm21.94 1.647v1.52H3.693v-1.52h24.614ZM3.693 10.894h24.614v1.52H3.693v-1.52ZM1.44 13.081h29.12a.773.773 0 0 1 .773.773v1.857H.667v-1.857a.774.774 0 0 1 .773-.773Zm29.27 15.4H12.22V16.378h19.113v9.65a5.19 5.19 0 0 1-.623 2.453Zm-29.42 0a5.19 5.19 0 0 1-.623-2.453v-9.65h7.53V28.48H1.29Zm7.573-12.103h2.69V28.48h-2.69V16.378ZM28.197 31.2H3.82a3.164 3.164 0 0 1-3-2.22.333.333 0 0 0 .29.167h29.793a.335.335 0 0 0 .29-.167 3.163 3.163 0 0 1-3.013 2.22h.017Z" />
        <path d="M21.667 18.69c-3.14 0-5.597 1.516-5.597 3.45 0 1.933 2.454 3.45 5.597 3.45 3.143 0 5.6-1.514 5.6-3.45 0-1.937-2.463-3.45-5.6-3.45Zm0 6.233c-2.667 0-4.93-1.273-4.93-2.783s2.263-2.784 4.93-2.784S26.6 20.63 26.6 22.14c0 1.51-2.266 2.783-4.933 2.783Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon5;
